import { useEffect, useState } from 'react';
import { PlusIcon } from '../../assets/icons/Auth/PlusIcon.jsx';
import { PlatformList } from '../../helpers/platformList';
import WhatsPROLogo from '../../assets/logos/WhatsPRO.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from 'use-http';
import { MAIN_API_URL } from '../../configuration/index.js';

// UI kit
import { Card, Spinner } from '@/components/ui';

const PendingSynchronizeView = () => {

    const params = useParams();
    const navigate = useNavigate();
    const query = new URLSearchParams(window.location.search);
    const { post, put, response } = useFetch(MAIN_API_URL + '/auth');

    const [shopPlatform, setShopPlatform] = useState(null);

    useEffect(() => {
        const platform = PlatformList.find((platform) => platform.name === params.platform);
        if (platform) {
            setShopPlatform(platform);
        } else {
            navigate('/auth/syncronize_failure/' + params.platform + '?error=Ocurrió un error en la sincronización de tu tienda. Por favor, inténtalo de nuevo.');
        }
    }, [params.platform, navigate]);

    useEffect(() => {
        async function fetchData() {
            if (shopPlatform) {
                const res = await post(`${shopPlatform.name}/code`, { code: query.get('code') });
                if (response.ok) {
                    const previousStoreOnboarding = JSON.parse(localStorage.getItem('storeOnboarding') || null);
                    const syncronizeId = localStorage.getItem('syncronizeId');
                    if (previousStoreOnboarding && (previousStoreOnboarding.storeId !== res.response.storeId || previousStoreOnboarding.origin !== shopPlatform.id)) {
                        navigate('/auth/syncronize_failure/' + params.platform + '?error=Ya tienes una sesión iniciada con otra tienda. Por favor, cierra este navegador, borra las cookies o intenta en incógnito con esta nueva tienda.');
                    }
                    localStorage.setItem('storeOnboarding', JSON.stringify({
                        storeId: res.response.storeId,
                        origin: shopPlatform.id,
                    }));
                    const hasStartLoginWithPlatform = JSON.parse(localStorage.getItem('hasStartLoginWithPlatform') || null);
                    if(syncronizeId){
                        localStorage.removeItem('syncronizeId');
                        const newRes = await put(`${shopPlatform.name}/update`, { storeId: res.response.storeId, _id: syncronizeId, code: query.get('code') });
                        if(newRes.status === 200){
                            localStorage.setItem('token', newRes.response.token);
                            localStorage.setItem('refreshToken', newRes.response.refreshToken);
                            localStorage.setItem('store', JSON.stringify(newRes.response._id));
                            localStorage.setItem('origin', newRes.response.origin);
                            localStorage.removeItem('storeOnboarding');
                            navigate('/home');
                        } else{
                            navigate('/auth/syncronize_failure/' + params.platform + '?error=' + newRes.msg);
                        }
                    }
                    if (hasStartLoginWithPlatform) {
                        localStorage.removeItem('hasStartLoginWithPlatform');
                        const newRes = await put(`${shopPlatform.name}/update`, { storeId: res.response.storeId, code: query.get('code') });
                        if(newRes.status === 200){
                            localStorage.setItem('token', newRes.response.token);
                            localStorage.setItem('refreshToken', newRes.response.refreshToken);
                            localStorage.setItem('store', JSON.stringify(newRes.response._id));
                            localStorage.setItem('origin', newRes.response.origin);
                            localStorage.removeItem('storeOnboarding');
                            navigate('/home');
                        } else{
                            navigate('/auth/syncronize_failure/' + params.platform + '?error=' + newRes.msg);
                        }
                    } else {
                        if(res.response.isRegistered){
                            navigate('/login?platform=' + params.platform);
                        } else{
                            navigate('/welcome');
                        }
                    }
                } else {
                    let error = 'unknown_error';
                    if (res.errors && res.errors.length > 0) {
                        error = res.errors[0].msg;
                    } else if(res.msg){
                        error = res.msg;
                    }
                    let errorInFormat = 'Error inesperado';
                    switch (error) {
                        case 'code is mandatory':
                        case 'code must be string':
                            errorInFormat = 'Ocurrió un error en la sincronización de tu tienda. Por favor, intentalo de nuevo';
                            break;
                        default:
                            errorInFormat = 'Ocurrió un error inesperado. Por favor, intentalo de nuevo';
                            break;
                    }
                    navigate('/auth/syncronize_failure/' + params.platform + '?error=' + errorInFormat);
                }
            }
        }
        fetchData();
    }, [shopPlatform]);

    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-background px-4">
            <Card className="w-full max-w-md overflow-hidden p-0 text-center">
                {/* deck accent bar — thin brand gradient, used sparingly */}
                <div className="h-1 w-full bg-grad" />
                <div className="flex flex-col items-center gap-6 px-8 py-12">
                    <Spinner className="h-14 w-14 border-[3px]" />
                    <div>
                        <h1 className="text-xl font-bold tracking-[-0.01em] text-foreground text-balance">
                            Sincronizando tu tienda con WhatsPRO
                        </h1>
                        <p className="mt-2 text-sm text-muted-foreground">
                            Esto puede tardar unos segundos. No cierres esta ventana.
                        </p>
                    </div>
                    {shopPlatform && (
                        <div className="mt-1 flex items-center gap-4">
                            <img src={shopPlatform.urlImage} alt="Logo" className="max-h-7 w-auto" />
                            <PlusIcon width={18} height={18} />
                            <img src={WhatsPROLogo} alt="WhatsPRO" className="max-h-7 w-auto" />
                        </div>
                    )}
                </div>
            </Card>
        </div>
    );
};

export { PendingSynchronizeView };
